var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAffiReason13(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 30V15C5.625 12.5136 6.61272 10.129 8.37087 8.37087C10.129 6.61272 12.5136 5.625 15 5.625H30C32.4864 5.625 34.871 6.61272 36.6291 8.37087C38.3873 10.129 39.375 12.5136 39.375 15V30C39.375 32.4864 38.3873 34.871 36.6291 36.6291C34.871 38.3873 32.4864 39.375 30 39.375H15C12.5136 39.375 10.129 38.3873 8.37087 36.6291C6.61272 34.871 5.625 32.4864 5.625 30Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9375 27.1875C30.9375 27.1875 28.125 30.9375 22.5 30.9375C16.875 30.9375 14.0625 27.1875 14.0625 27.1875",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1875 19C13.8726 19 13.5705 18.8946 13.3478 18.7071C13.1251 18.5196 13 18.2652 13 18C13 17.7348 13.1251 17.4804 13.3478 17.2929C13.5705 17.1054 13.8726 17 14.1875 17C14.5024 17 14.8045 17.1054 15.0272 17.2929C15.2499 17.4804 15.375 17.7348 15.375 18C15.375 18.2652 15.2499 18.5196 15.0272 18.7071C14.8045 18.8946 14.5024 19 14.1875 19ZM30.8125 19C30.4976 19 30.1955 18.8946 29.9728 18.7071C29.7501 18.5196 29.625 18.2652 29.625 18C29.625 17.7348 29.7501 17.4804 29.9728 17.2929C30.1955 17.1054 30.4976 17 30.8125 17C31.1274 17 31.4295 17.1054 31.6522 17.2929C31.8749 17.4804 32 17.7348 32 18C32 18.2652 31.8749 18.5196 31.6522 18.7071C31.4295 18.8946 31.1274 19 30.8125 19Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAffiReason13);
export default __webpack_public_path__ + "static/media/affiReason13.ec5108ea499d7f765fe621fa33a060a6.svg";
export { ForwardRef as ReactComponent };